import { animate, useMotionValue } from 'framer-motion';
import { useEffect, useState } from 'react';

/** Tweens from 0 to `value` whenever `value` changes. */
export default function AnimatedNumber({ value }) {
  const mv = useMotionValue(0);
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const controls = animate(mv, value || 0, {
      duration: 0.9,
      ease: [0.2, 0.8, 0.2, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return controls.stop;
  }, [mv, value]);

  return <>{display}</>;
}
